import { useEffect, useContext } from 'react'
import { PageHeaderContext } from '@contexts/pageHeader'

export const usePageHeader = () => {
  const { dispatch: pageHeaderDispatch } = useContext(PageHeaderContext)

  useEffect(() => {
    pageHeaderDispatch({
      type: 'setPageHeader',
      payload: {
        breadcrumbs: [{ label: 'Data Standards / Dashboard', path: '/dashboard' }],
        variant: 'condensed',
      },
    })

    return () => {
      pageHeaderDispatch({
        type: 'setPageHeader',
        payload: { breadcrumbs: [], variant: 'condensed' },
      })
    }
  }, [])
}
